import { createFileRoute, redirect } from "@tanstack/react-router";

// Banners is a tab of Management.
export const Route = createFileRoute("/st-admin/banners/")({
	beforeLoad: () => {
		throw redirect({
			to: "/st-admin/management",
			search: { tab: "banners" },
			replace: true,
		});
	},
});
